import gql from 'graphql-tag'

export const getUserForResubscribeQuery = gql`
  query GetUserProfile {
    getUserProfile {
      id
      isAdmin
      client {
        id
        name
        subscription {
          id
          canceled
        }
      }
    }
  }
`
